import _ from 'lodash'
import md5 from 'blueimp-md5'
import PublicQa from './PublicQa.js'
import {
  buildUrl
} from '@/util.js'
export default {
  namespaced: true,
  modules: {
    PublicQa
  },
  actions: {
    async r ({dispatch, rootState, rootGetters}, options) {
      let key = 'ranch'
      let url = options.url
      options.url = buildUrl(rootGetters.rootDomain, key, url)
      options.method = 'post'

      let authFailReLaunch = false
      if (options.hasOwnProperty('authFailReLaunch')) {
        authFailReLaunch = options.authFailReLaunch
        delete options.authFailReLaunch
      }
      let bypass = false
      if (options.hasOwnProperty('bypass')) {
        bypass = options.bypass
        delete options.bypass
      }
      let res = await dispatch('api/r', options, {root: true})

      if (bypass) {
        return res.data
      }
      let code = _.get(res, 'data.code')
      if (code === 0) {
        return _.get(res, 'data.data')
      }

      if (authFailReLaunch && code === 2205) { // auth failed, force relogin
        // await dispatch('me/logout', null, {root: true})
        window.reload()
        throw new Error(`登入授权失效，请重新登入`)
      }

      let msg = _.get(res, 'data.msg', `请求失败。`)
      let moreInfo = [key, url, res.status, code]
      if (msg) {
        if (code === 5233) { // 投遞訂單不存在
          moreInfo.push(JSON.stringify(options.data))
        }
      }
      if (rootState.env === 'prod') {
        msg = `${msg}(${moreInfo.join(', ')})`
      }
      throw new Error(msg)
    },
    async userSignIn ({dispatch}, {
      type = 2,
      uid,
      password = 'dartcome.web'
    }) {
      let sid = `dartcome:${md5(uid, password)}`
      let data = await dispatch('r', {
        url: '/user/sign-in',
        data: {
          type,
          uid,
          password
        },
        headers: {
          'tephra-session-id': sid
        }
      })
      dispatch('set', {
        path: 'sid',
        value: sid
      }, {root: true})
      return data
    },
    async userSendResetPasswordSms ({dispatch}, {mobile, product = '大咖投资人'}) {
      let data = await dispatch('r', {
        url: '/user/send-reset-password-sms',
        data: {
          appCode: `dartcome`,
          mobile,
          args: JSON.stringify({
            product
          })
        }
      })
      if (!data) {
        throw new Error('发送失败')
      }
      return data
    },
    async userResetPassword ({dispatch}, {uid, password, smsCode}) {
      let data = await dispatch('r', {
        url: '/user/reset-password',
        data: {
          uid,
          password,
          smsCode
        }
      })
      return data
    },
    async upload ({dispatch}, {key = 'ranch.deliver.attachment', file}) {
      let formData = new FormData()
      formData.append(key, file)

      let data = await dispatch('r', {
        url: '/tephra/ctrl-http/upload',
        data: formData,
        bypass: true
      })
      // data may be list<object> or object
      let success = _.get(data, '[0].success') || _.get(data, 'success')
      if (!success) {
        let msg = _.get(data, '[0].message') || _.get(data, 'message') || 'upload failed'
        throw new Error(msg)
      }
      return data
    },
    async deliverFind ({dispatch}, {id}) {
      let data = await dispatch('r', {
        url: '/deliver/find',
        data: {id}
      })
      return data
    },
    async deliverFree ({dispatch}, params) {
      let data = await dispatch('r', {
        url: '/deliver/free',
        data: params
      })
      return data
    },
    async deliverCreate ({dispatch}, params) {
      let data = await dispatch('r', {
        url: '/deliver/create',
        data: params
      })
      return data
    },
    async deliverCount ({dispatch}, {investor, state = 8}) {
      let data = await dispatch('r', {
        url: '/deliver/count',
        data: {
          investor,
          state
        }
      })
      return data
    },
    async deliverQaSends ({dispatch}, {user}) {
      let data = await dispatch('r', {
        url: '/deliver/qa/sends',
        data: {user}
      })
      return data
    },
    async investorUsave ({dispatch}, {
      deliverPrice,
      state
    }) {
      let data = await dispatch('r', {
        url: '/investor/usave',
        data: {
          deliverPrice,
          state
        }
      })
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api/ranch/index.js